/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'tgv-loading',
  standalone: false,
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {
  @Input() text: string;
}
